import React from 'react'

import { cn } from '@/utilities/ui'

/** VR/Icon/Arrow Right - exact path from the design, filled with currentColor so buttons can recolour it. */
export function ArrowRight({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 12 12"
      className={className}
      fill="currentColor"
      aria-hidden
      focusable="false"
    >
      <path d="M6 12L4.93125 10.95L9.13125 6.75H0V5.25H9.13125L4.93125 1.05L6 0L12 6L6 12Z" />
    </svg>
  )
}

/** VR/Icon/Arrow Up - for a jump back up the same page. */
export function ArrowUp({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 12 12"
      className={className}
      fill="currentColor"
      aria-hidden
      focusable="false"
    >
      <path d="M0 6L1.05 7.06875L5.25 2.86875V12H6.75V2.86875L10.95 7.06875L12 6L6 0L0 6Z" />
    </svg>
  )
}

/** Three-bar menu glyph, stroked in currentColor. The app's icon set has no hamburger. */
export function MenuIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden
      focusable="false"
    >
      <path d="M1 3.5h14M1 8h14M1 12.5h14" />
    </svg>
  )
}

/** VR/Corner Bracket - an L of two 1px arms. Rotate for the other three corners. */
export function CornerBracket({ className, size = 28 }: { className?: string; size?: number }) {
  return (
    // `relative` first so a caller's `absolute` wins the merge but the arms always have an anchor.
    <span
      className={cn('relative block', className)}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <span className="absolute left-0 top-0 h-px bg-current" style={{ width: size }} />
      <span className="absolute left-0 top-0 w-px bg-current" style={{ height: size }} />
    </span>
  )
}

/** VR/Icon/Calendar - exact paths from the design, stroked in currentColor so buttons can recolour it. */
export function Calendar({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 12 12"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d="M9.5 1.99988H2.5C1.94772 1.99988 1.5 2.44759 1.5 2.99988V9.99988C1.5 10.5522 1.94772 10.9999 2.5 10.9999H9.5C10.0523 10.9999 10.5 10.5522 10.5 9.99988V2.99988C10.5 2.44759 10.0523 1.99988 9.5 1.99988Z" />
      <path d="M8 1.00012V3.00012" />
      <path d="M4 1.00012V3.00012" />
      <path d="M1.5 4.99988H10.5" />
    </svg>
  )
}

/** VR/Icon/Download */
export function Download({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 12 12"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      aria-hidden
      focusable="false"
    >
      <path d="M6 0.5v7.5M2.75 5.25L6 8.5l3.25-3.25M0.75 11.25h10.5" />
    </svg>
  )
}

/** VR/Crosshair - a registration plus of two 1px arms. Geometry, so it is drawn rather than exported. */
export function Crosshair({ className, size = 16 }: { className?: string; size?: number }) {
  return (
    <span
      className={cn('relative block', className)}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <span className="absolute left-0 top-1/2 h-px w-full -translate-y-1/2 bg-current" />
      <span className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-current" />
    </span>
  )
}
